exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LogoTitle-module__logoContainer--11AiX {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-top: 32px;\r\n}\r\n\r\n/*임시로 영역을 잡아줌*/\r\n.LogoTitle-module__logo--3EJhL {\r\n}\r\n\r\n.LogoTitle-module__content--3sERh {\r\n    margin-top: 24px;\r\n    font-family: Noto Sans KR;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.43;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: #555555;\r\n}", ""]);

// exports
exports.locals = {
	"logoContainer": "LogoTitle-module__logoContainer--11AiX",
	"logo": "LogoTitle-module__logo--3EJhL",
	"content": "LogoTitle-module__content--3sERh"
};